export default __webpack_public_path__ + "static/media/three.77c91a10.jpg";